import { render, staticRenderFns } from "./Co2Emission.vue?vue&type=template&id=7140f7a6&"
import script from "./Co2Emission.vue?vue&type=script&lang=ts&"
export * from "./Co2Emission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports